import React from 'react';

import type { FactureContextType } from './FactureContext';

const FacturePrelevementContext = React.createContext<FactureContextType>({
  total: 0,
  factures: [],
  filters: [],
  search: '',
  sorts: {},
  setFactures: () => {},
  setFilters: () => {},
  setSearch: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  getFactures: () => {},
  applyDefaultFilters: () => {},
});

export default FacturePrelevementContext;
